import { Component, Input } from '@angular/core';
import { TrendChartVm, TrendLegendItemVm, TrendSeries } from '../../../../domain/model/trend-metrics.model';

/** Grouped bars of submitted, approved and funded counts per bucket, with an HTML legend. */
@Component({
  selector: 'ifbp-trend-volume-chart',
  templateUrl: './trend-volume-chart.component.html',
  styleUrls: ['./trend-volume-chart.component.scss'],
  standalone: false,
})
export class TrendVolumeChartComponent {
  @Input() vm: TrendChartVm;

  trackBySeries(_index: number, item: TrendLegendItemVm): TrendSeries {
    return item.series;
  }
}
